import axios from "axios"

var config 
const fetchConfig = async () =>  {
    const { data } = await axios.get(document.location.origin + '/config.json')
    config = data 
    return config
}

export { fetchConfig }
export default () => (config)